import { CommonModule } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {faAdd, faDownload} from "@fortawesome/free-solid-svg-icons";
import {DropdownMenuComponent, MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {DropdownSearchComponent} from "../../../../shared/ui/dropdown-search/dropdown-search.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../../shared/ui/full-button/full-button.component";
import {
  PerPagePaginationComponent
} from "../../../../shared/ui/pagination/per-page-pagination/per-page-pagination.component";
import {Pagination} from "../../exam-submissions/exam-submissions.component";
import {ClearButtonComponent} from "../../../../shared/ui/clear-button/clear-button.component";
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import { DeleteConfirmationComponent } from "src/app/shared/ui/delete-confirmation/delete-confirmation.component";
import {
  Arabic_Survey10, Arabic_Survey12,
  Arabic_Survey2, Chinese_Survey10a, Chinese_Survey11a, Chinese_Survey12, Chinese_Survey13, Chinese_Survey14a,
  Chinese_Survey15, Chinese_Survey16, Chinese_Survey17, Chinese_Survey18, Chinese_Survey19, Chinese_Survey20,
  Chinese_Survey8a,
  Chinese_Survey8b,
  Chinese_Survey9a,
  Chinese_Survey9b,
  English_Camden_Survey1, English_Camden_Survey2,
  English_Camden_Survey3,
  English_Camden_Survey4,
  English_Camden_Survey5, EnglishNB_Survey1, EnglishNB_Survey2, EnglishNB_Survey3, EnglishNB_Survey4, EnglishNB_Survey5,
  GermanNB_Survey, Hindi_Survey, Italian_Survey1, Polish_Survey
} from "./survey-question-enum";

interface ReportItem {
  name: string,
  report_id: number,
  author: string,
  user_id:  number,
  createdate: Date,
  lastupdated: Date
  menuItems: MenuItem[]
}
@Component({
    selector: 'exam-export-list',
    templateUrl: './exam-export-list.component.html',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css', './exam-report-list.component.css'],
    imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, PerPagePaginationComponent, ClearButtonComponent, BreadcrumbComponent, DeleteConfirmationComponent]
})
export class ExamExportListComponent implements OnInit {
  constructor(private examService: ExamService, private route: ActivatedRoute, private _snackBar: MatSnackBar) {}
  router = inject(Router)
  examID = -1
  examReports: ReportItem[] = []
  runReportDialog = false
  reportMode = 'STANDARD'
  reportID = -1
  reportName = ''
  reportHeaders: string[] = []
  reportValues: string[][] = []
  reportRequiredStart = new Date()
  reportRequiredFinish = new Date()
  reportRequiredGrade = true
  reportRunIsSuccess = false
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  accentPrimaryColor = `accent-color: ${localStorage.getItem('primaryColor')};`
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Exam List',
    route: 'dashboard/exam/list'
  }]
  showDeleteDialog = false
  isEnglish = false;
  isPolish = false;
  isArabic = false;
  isChinese = false;
  isEnglishCamden = false;
  isGermanNB = false;
  isHindi = false;
  isItalian = false;
  isSpanish = false
  isMathCamden = false
  isPortuguese = false
  filter_column_string = ''
  filter_column_index = -1


  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if(params['exam_id']) {
        this.examID = params['exam_id']
        this.handleServiceCall()
      }
    })
  }

  runReport() {
    this.reportRunIsSuccess = true

    this.examService.exportReportRun(this.reportID, this.reportRequiredGrade).subscribe((response) => {
      if(response.success) {
        this.reportRunIsSuccess = true
        this.reportHeaders = response.result.column_names
        this.reportValues = response.result.records
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  cancelRunReport() {
    this.reportValues = []
    this.reportHeaders = []
    this.reportRunIsSuccess = false
    this.runReportDialog = false
    this.reportID = -1
    this.reportName = ''
    this.filter_column_string = ''
    this.filter_column_index = -1
  }

  handleServiceCall() {
    this.examService.exportReportList(this.examID, this.currentPagination.limit, this.currentPagination.page).subscribe((response) => {
      this.examReports = []
      if(response.success) {
        for(let report of response.result.items) {
          this.isEnglish = report.exam_title.toLowerCase().includes('english') && report.exam_title.toLowerCase().includes('new brunswick');
          this.isPolish = report.exam_title.includes('Polish');
          this.isArabic = report.exam_title.includes('Arabic');
          this.isChinese = report.exam_title.includes('Chinese');
          this.isEnglishCamden = report.exam_title.toLowerCase().includes('english') && report.exam_title.toLowerCase().includes('camden');
          this.isGermanNB = report.exam_title.toLowerCase().includes('german') && report.exam_title.toLowerCase().includes('new brunswick');
          this.isHindi = report.exam_title.includes('Hindi');
          this.isItalian = report.exam_title.includes('Italian');
          this.isSpanish = report.exam_title.includes('Spanish');
          this.isMathCamden = report.exam_title.toLowerCase().includes('math') && report.exam_title.toLowerCase().includes('camden');
          this.isPortuguese = report.exam_title.toLowerCase().includes('portuguese ')

          // TODO: NOTE a lot of the survey questions are yes or no. Need to check the name of the exam to determine which exam it is

          this.examReports.push({
            ...report,
            menuItems: [{
              title: 'Run',
              action: () => {
                this.runReportDialog = true
                this.reportID = report.report_id
                this.reportName = report.exam_title
              }
            },{
              title: 'Edit',
              route: 'dashboard/exam/export/config',
              queryParams: {queryParams: {exam_id: report.exam_id, report_id: report.report_id}}
            },{
              title: 'Delete',
              action: () => {
                this.showDeleteDialog = true
                this.reportID = report.report_id
              }
            }]
          })
        }
        this.currentPagination.page = response.result.page
        this.currentPagination.size = response.result.size
      } else if(response.msg !== 'no reports found') {
        // TODO check for invalid scope response
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  createNewCSV() {
    this.router.navigate(['dashboard/exam/export/config'], {queryParams: {exam_id: this.examID}})
  }

  confirmDelete() {
    this.examService.exportConfigDelete(this.reportID).subscribe((response) => {
      if(response.success) {
        this.showDeleteDialog = false
        this._snackBar.open('Report Successfully Deleted', 'Dismiss', {duration: 3000})
        this.handleServiceCall()
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  indexToLetter(index: number | null): string {
    if (index === null || index < 0 || index > 25) return '';
    return String.fromCharCode('A'.charCodeAt(0) + index);
  }

  isNumeric(str: string): boolean {
    return str !== '' && !isNaN(Number(str));
  }

  downloadCSV() {
    const csvHeaders = this.reportHeaders
    for(let i = 0; i < csvHeaders.length; i++) {
      csvHeaders[i] = `"${csvHeaders[i]}"`
    }
    let values: string = csvHeaders.join(',')
    values += '\n'

    this.filter_column_string = this.filter_column_string.replaceAll(' ', '')
    if(this.filter_column_string.endsWith(',')) {
      this.filter_column_string = this.filter_column_string.slice(0, -1)
    }
    let filter_string_array = this.filter_column_string.split(',');

    if (filter_string_array.length > 0 && this.filter_column_index !== -1) {
      this.reportValues = this.reportValues.filter((value) => filter_string_array.includes(value[this.filter_column_index]))
    }

    for(let record of this.reportValues) {
      let skip_record = false
      for(let i = 0; i < record.length; i++) {
        let tempRecord = record[i]
        if(this.isISO8601(record[i])) {
          const date = new Date(record[i])
          const dateOptions: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
          const timeOptions: Intl.DateTimeFormatOptions = { hour: 'numeric', minute:'numeric', hourCycle: 'h12'};
          record[i] = date.toLocaleDateString('en', dateOptions) + " " + date.toLocaleTimeString('en', timeOptions)
        }

        // TODO need to do a check that it is also a placement exam later when we add classroom
        if(this.isEnglish) {
          if(i === 2 || i === 8)
            Object.keys(EnglishNB_Survey1)
              .filter(key => isNaN(Number(key))) // Filter out numeric keys
              .forEach((response: string, index: number) => {
                if(response.includes(record[i])) {
                  let num = index + 1
                  record[i] = num.toString()
                }
              });
          if(i === 3 || i === 9)
            Object.keys(EnglishNB_Survey2)
              .filter(key => isNaN(Number(key))) // Filter out numeric keys
              .forEach((response: string, index: number) => {
                if(response.includes(record[i])) {
                  let num = index + 1
                  record[i] = num.toString()
                }
              });

          if(i === 4 || i === 10)
            Object.keys(EnglishNB_Survey3)
              .filter(key => isNaN(Number(key))) // Filter out numeric keys
              .forEach((response: string, index: number) => {
                if(response.includes(record[i])) {
                  let num = index + 1
                  record[i] = num.toString()
                }
              });

          if(i === 5 || i === 11)
            Object.keys(EnglishNB_Survey4)
              .filter(key => isNaN(Number(key))) // Filter out numeric keys
              .forEach((response: string, index: number) => {
                if(response.includes(record[i])) {
                  let num = index + 1
                  record[i] = num.toString()
                }
              });

          if(i === 6 || i === 12)
            Object.keys(EnglishNB_Survey5)
              .filter(key => isNaN(Number(key))) // Filter out numeric keys
              .forEach((response: string, index: number) => {
                if(response.includes(record[i])) {
                  let num = index + 1
                  record[i] = num.toString()
                }
              });

          if(i === 7) {
            if(record[i] && !csvHeaders[i].includes('act_best_reading')) {
              const tempStr = record[i]
              const word_count = tempStr.toString().trim().split(/\s+/).length
              record[i] = Number(word_count >= 200).toString()
            } else if(!csvHeaders[i].includes('act_best_reading')) {
              record[i] = "0"
            }
          }

          if((record[i] === 'n/a' || /^\s*$/.test(record[i])) && (csvHeaders[i].includes('Part 2 Time') ||
            csvHeaders[i].includes('Part 3 Time') || csvHeaders[i].includes('Part 4 Time'))) {
            skip_record = true
          }
        }

        if(this.isPolish && i < 10 && i > 4) {
          if(record[i] === 'Yes' || record[i] === 'No') {
            record[i] = record[i][0]
          }
        }

        if(this.isPortuguese) {
          if(csvHeaders[i].includes('STUDYYEARS') && this.isNumeric(record[i])) {
            record[i] = this.indexToLetter(Number(record[i]))
          }
        }

        if(this.isEnglishCamden) {
          if(i >= 2 && i <= 6 && csvHeaders[i].includes('1:'))
            record[i] = record[i] + 1

          if(i >= 7 && i <= 11 && csvHeaders[i].includes('Response'))
            record[i] = record[i] + 1

          if(i === 7 || i === 12) {
            if(record[i] && !csvHeaders[i].includes('act_best_reading') && csvHeaders[i].includes('Part 2 Score')) {
              const tempStr = record[i]
              const word_count = tempStr.toString().trim().split(/\s+/).length
              record[i] = Number(word_count >= 200).toString()
            } else if(record[i] == null && csvHeaders[i].includes('Part 2 Score')) {
              record[i] = "0"
            }
          }

          if((record[i] === 'n/a' || /^\s*$/.test(record[i])) && (csvHeaders[i].includes('Part 2 Time') ||
            csvHeaders[i].includes('Part 3 Time') || csvHeaders[i].includes('Part 4 Time')
            || csvHeaders[i].includes('End Date & Time') || csvHeaders[i].includes('Spent Time'))) {
            skip_record = true
          }
        }

        if(this.isGermanNB) {
          if(i === 4) {
            record[i] = record[i] + 1
          }

          if(record[i] == null) {
            record[i] = ""
          }
        }

        if(this.isHindi) {
          Object.keys(Hindi_Survey)
            .filter(key => isNaN(Number(key))) // Filter out numeric keys
            .forEach((response: string, index: number) => {
              if(response.includes(record[i])) {
                let num = index + 1
                record[i] = num.toString()
              }
            });
        }

        if(this.isItalian && i === 20) {
          if(record[i] === 'Yes' || record[i] === 'No')
            record[i] = record[i].toLowerCase()[0]
        }

        if(this.isMathCamden) {
          if((record[i] === 'n/a' || /^\s*$/.test(record[i])) && (csvHeaders[i].includes('Part 2 Time') ||
            csvHeaders[i].includes('Part 3 Time') || csvHeaders[i].includes('Part 4 Time')
            || csvHeaders[i].includes('End Date & Time') || csvHeaders[i].includes('Spent Time'))) {
            skip_record = true
          }
        }

        if(record[i] == null) {
          record[i] = ""
        }

        record[i] = this.escapeForCsv(record[i])
      }
      if(!skip_record || !this.reportRequiredGrade) {
        values += record.join(',')
        values += '\n'
      }
    }

    const blob = new Blob([values], {type: 'text/csv'})
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a');
    a.href = url
    a.download = this.reportName + '.csv'
    a.click()
    this.cancelRunReport()
  }

  escapeForCsv(value: string): string {
    // Check if the value contains a comma, double quote, or newline character
    const needsQuotes = /[,"' \n\r]/.test(value);

    if (!needsQuotes) {
      return value;
    }

    // Escape internal double quotes by replacing them with two double quotes
    const escapedValue = value.replace(/"/g, '""');

    // Enclose the entire field in double quotes
    return `"${escapedValue}"`;
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  isISO8601(value: string) {
    try {
      const isoPattern = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
      return isoPattern.test(value)
    } catch (e) {
      return false
    }
  }

  protected readonly faAdd = faAdd;
  protected readonly faDownload = faDownload;
}
